import React from 'react';
import { featuredMatch as M } from '../mock';
import { useI18n } from '../i18n';
import { MapPin, Sparkles } from 'lucide-react';

function Badge({ team }) {
  return (
    <div style={{ width: 46, height: 52, borderRadius: '8px 8px 20px 20px', background: `linear-gradient(160deg, ${team.colors[0]}, ${team.colors[1]})`, border: '2px solid rgba(255,255,255,0.16)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 8px 22px rgba(0,0,0,0.5)' }}>
      <span className="font-display" style={{ fontSize: 14, color: team.text }}>{team.short}</span>
    </div>
  );
}

export default function PhoneMock({ width = 300 }) {
  const { t } = useI18n();
  return (
    <div className="phone-frame" style={{ width }}>
      <div className="phone-screen">
        <div style={{ position: 'relative', padding: '18px 16px 16px', overflow: 'hidden' }}>
          <img src={require('../mock').assets.stadium} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.28 }} />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(6,8,14,0.5), rgba(6,8,14,0.92))' }} />
          <div style={{ position: 'relative' }}>
            <div style={{ textAlign: 'center', fontSize: 10, letterSpacing: '0.22em', color: 'var(--hm-gold)', fontWeight: 700 }}>{t.phone.competition}</div>
            <div style={{ marginTop: 12, display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center', gap: 8 }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }} className="float-slow"><Badge team={M.home} /><span style={{ fontSize: 11, fontWeight: 600 }}>Real Madrid</span></div>
              <div style={{ textAlign: 'center' }}>
                <div className="font-sora" style={{ fontSize: 26, fontWeight: 800, color: '#fff', lineHeight: 1 }}>21<span style={{ opacity: 0.6 }}>:</span>00</div>
                <div style={{ fontSize: 10, color: 'var(--color-neutral-500)', marginTop: 2 }}>{t.phone.date}</div>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }} className="float-slow"><Badge team={M.away} /><span style={{ fontSize: 11, fontWeight: 600 }}>Inter</span></div>
            </div>
            <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5, fontSize: 10.5, color: 'var(--color-neutral-400)' }}><MapPin size={12} color="var(--color-neutral-500)" /> {t.phone.venue}</div>
          </div>
        </div>
        <div style={{ height: 2, background: 'linear-gradient(90deg, transparent, var(--hm-gold), transparent)', backgroundSize: '200% 100%', animation: 'goldSweep 3s linear infinite' }} />
        <div className="fade-in" style={{ padding: '14px 16px 18px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 8 }}>
            <Sparkles size={13} color="var(--hm-gold)" />
            <span style={{ fontSize: 10.5, letterSpacing: '0.16em', fontWeight: 700, color: 'var(--hm-gold)' }}>{t.phone.aiLabel}</span>
          </div>
          <p style={{ margin: 0, fontSize: 11.5, lineHeight: 1.65, color: 'var(--color-neutral-400)' }}>{t.phone.analysis}</p>
        </div>
      </div>
    </div>
  );
}
